"use strict";
/**
 * Copyright 2023 actions-toolkit authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Util = void 0;
const fs_1 = __importDefault(require("fs"));
const core = __importStar(require("@actions/core"));
const io = __importStar(require("@actions/io"));
const sync_1 = require("csv-parse/sync");
class Util {
    static getInputList(name, opts) {
        const res = [];
        const items = core.getInput(name);
        if (items == '') {
            return res;
        }
        const records = (0, sync_1.parse)(items, {
            columns: false,
            relaxQuotes: true,
            comment: '#',
            relaxColumnCount: true,
            skipEmptyLines: true,
            quote: opts === null || opts === void 0 ? void 0 : opts.quote
        });
        for (const record of records) {
            if (record.length == 1) {
                if (opts === null || opts === void 0 ? void 0 : opts.ignoreComma) {
                    res.push(record[0]);
                }
                else {
                    res.push(...record[0].split(','));
                }
            }
            else if (!(opts === null || opts === void 0 ? void 0 : opts.ignoreComma)) {
                res.push(...record);
            }
            else {
                res.push(record.join(','));
            }
        }
        return res.filter(item => item).map(pat => pat.trim());
    }
    static asyncForEach(array, callback) {
        return __awaiter(this, void 0, void 0, function* () {
            for (let index = 0; index < array.length; index++) {
                yield callback(array[index], index, array);
            }
        });
    }
    static isValidUrl(url) {
        try {
            new URL(url);
        }
        catch (e) {
            return false;
        }
        return true;
    }
    static powershellCommand(script, params) {
        return __awaiter(this, void 0, void 0, function* () {
            const powershellPath = yield io.which('powershell', true);
            const escapedScript = script.replace(/'/g, "''").replace(/"|\n|\r/g, '');
            const escapedParams = [];
            if (params) {
                for (const key in params) {
                    escapedParams.push(`-${key} '${params[key].replace(/'/g, "''").replace(/"|\n|\r/g, '')}'`);
                }
            }
            return {
                command: `"${powershellPath}"`,
                args: ['-NoLogo', '-Sta', '-NoProfile', '-NonInteractive', '-ExecutionPolicy', 'Unrestricted', '-Command', `& '${escapedScript}' ${escapedParams.join(' ')}`]
            };
        });
    }
    static isDirectory(p) {
        try {
            return fs_1.default.lstatSync(p).isDirectory();
        }
        catch (_) {
            // noop
        }
        return false;
    }
}
exports.Util = Util;
//# sourceMappingURL=util.js.map